export function formatDurationMinutes(minutes: number): string {
  if (minutes <= 0) return '0 min'
  const minutesPerHour = 60
  const minutesPerDay = 1440
  if (minutes >= minutesPerDay) {
    const days = Math.floor(minutes / minutesPerDay)
    const hours = Math.floor((minutes % minutesPerDay) / minutesPerHour)
    if (hours > 0) return `${days} d ${hours} h`
    return `${days} d`
  }
  if (minutes >= minutesPerHour) {
    const hours = Math.floor(minutes / minutesPerHour)
    const remainingMinutes = minutes % minutesPerHour
    if (remainingMinutes > 0) return `${hours} h ${remainingMinutes} min`
    return `${hours} h`
  }
  return `${minutes} min`
}
